export default class AuthStorageService {
  constructor(localStorageService, key = 'auth') {
    this.localStorageService = localStorageService;
    this.key = key;
  }

  setAuth(auth) {
    if (auth && auth.access_token && auth.expires_in) {
      const expiresAt = new Date();
      expiresAt.setSeconds(expiresAt.getSeconds() + auth.expires_in);
      auth.expires_at = expiresAt;
      delete auth.expires_in;
      this.localStorageService.set(this.key, auth);
    } else {
      this.localStorageService.remove(this.key);
    }
  }

  getAuth() {
    return this.localStorageService.get(this.key);
  }

  removeAuth() {
    return this.localStorageService.remove(this.key);
  }

  isAuthValid(auth) {
    return !!auth && !!auth.access_token && !!auth.expires_at;
  }

  isAuthenticated() {
    const auth = this.getAuth();
    if (!auth || !this.isAuthValid(auth)) {
      return false;
    }
    return true;
  }

  isAuthExpired(auth) {
    return new Date().getTime() > new Date(auth.expires_at).getTime();
  }
}
